/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import {
  styled,
  createTheme,
  ThemeProvider,
} from '@mui/material/styles';
import { useAuth } from '../../services/cognito';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
// import MuiDrawer from '@mui/material/Drawer';
import Drawer from '@mui/material/Drawer';

import Box from '@mui/material/Box';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import { Toolbar, Grid } from '@mui/material';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { PrivateRoute } from '../../services/cognito';
import BlackBox from './blank';
import { MainListItems } from './listItems';
import { Layer0 } from '../layers/Layer0';
import { Layer1 } from '../layers/Layer1';
import { Layer2 } from '../layers/Layer2';
import { CartWitnessingPage } from '../cart/CwRequest';
import AdminPage from '../admin/AdminPage';
import S13Page from '../s13/S13Page';

const drawerWidth: number = 240;

const Main = styled('main', { shouldForwardProp: prop => prop !== 'open' })<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(0),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  // // marginLeft: `-${drawerWidth}px`,
  // width: `calc(100% - ${drawerWidth}px)`,
  // ...(open && {
  //   transition: theme.transitions.create('margin', {
  //     easing: theme.transitions.easing.easeOut,
  //     duration: theme.transitions.duration.enteringScreen,
  //   }),
  //   marginLeft: 0,
  // }),
}));

interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: prop => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: `${drawerWidth}px`,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const mdTheme = createTheme();

function MainBox() {
  return (
    <Routes>
      <Route path="/map" element={<Layer0 />} />
      <Route path="/map/:mapLayer1" element={<Layer1 />} />
      <Route path="/map/:mapLayer1/:mapLayer2" element={<Layer2 />} />
      <Route path="/cart" element={<CartWitnessingPage />} />
      <Route path="/admin" element={<AdminPage />} />
      <Route path="/s13" element={<S13Page />} />
      <Route path="*" element={<BlackBox />} />
    </Routes>
  );
}

function DashboardContent() {
  const { isAuthenticated, userProfile, login, logout } = useAuth();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  return (
    <BrowserRouter>
      <ThemeProvider theme={mdTheme}>
        <Box sx={{ display: 'flex' }}>
          <CssBaseline />
          <AppBar position="absolute" open={open}>
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{ mr: 2, ...(open && { display: 'none' }) }}
              >
                <MenuIcon />
              </IconButton>
              <Grid
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Grid item>
                  <Typography variant="h6" noWrap component="div">
                    구역관리
                  </Typography>
                </Grid>
                {!isAuthenticated && (
                  <Grid item>
                    <Button
                      color="inherit"
                      variant="outlined"
                      onClick={() => {
                        // This shouldn't happen as non-authenticated users see AuthContainer
                        console.log('Login button clicked but user should be at login screen');
                      }}
                    >
                      {' '}
                      Login
                    </Button>
                  </Grid>
                )}
                {isAuthenticated && userProfile && (
                  <Grid item>
                    <Grid
                      container
                      direction="row"
                      justifyContent="flex-end"
                      alignItems="center"
                    >
                      <Box
                        component="span"
                        sx={{
                          display: 'block',
                          justifyContent: 'flex-end',
                          pr: 2,
                        }}
                      >
                        <Typography
                          variant="body2"
                          align="right"
                          noWrap
                          component="div"
                        >
                          {`${userProfile.fullKoreanName || userProfile.name || 'Unknown User'} 님`}
                        </Typography>
                        <Typography variant="body2" noWrap component="div">
                          {userProfile.email}
                        </Typography>
                      </Box>
                      <Button
                        color="inherit"
                        variant="outlined"
                        onClick={() => logout()}
                        sx={{ ...(open && { display: 'none' }) }}
                      >
                        {' '}
                        Logout
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </Grid>
            </Toolbar>
          </AppBar>
          <Drawer
            sx={{
              width: drawerWidth,
              flexShrink: 0,
              '& .MuiDrawer-paper': {
                width: drawerWidth,
                boxSizing: 'border-box',
              },
            }}
            // variant="persistent"
            anchor="left"
            open={open}
            onClose={handleDrawerClose}
          >
            <DrawerHeader>
              <IconButton onClick={handleDrawerClose}>
                <ChevronLeftIcon />
              </IconButton>
            </DrawerHeader>
            <Divider />
            <Box
              role="presentation"
              onClick={handleDrawerClose}
              onKeyDown={handleDrawerClose}
            >
              <List component="nav">
                <MainListItems />
                <Divider sx={{ my: 1 }} />
                {/* {secondaryListItems} */}
              </List>
            </Box>
          </Drawer>
          <Main open={open}>
            <DrawerHeader />
            <MainBox />
          </Main>
        </Box>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default function Dashboard() {
  return (
    <PrivateRoute>
      <DashboardContent />
    </PrivateRoute>
  );
}
